<template>
  <div slot="item" :class="[className, { reset }]">
    <esi :src="src" />
  </div>
</template>

<style scoped>
  .container {
    padding: 0 calc(12vw - 5.25rem);
    margin: 3% 0 1.5em calc(50% - 50vw);
    margin: 3% auto 1.5em;
    box-sizing: border-box;
  }

  .reset {
    padding: 0;
    margin: 0;
  }

  .container :global(figcaption) {
    margin: 0;
  }

  .image-reference--F11 > :global(div) {
    max-width: 700px;
    margin: 0 auto;
  }

  @media (max-width: 899px) {
    .container :global(figcaption) {
      margin: 0 1.25rem;
    }
  }
</style>

<script>
import Esi from '../../Utilities/Esi.vue'

export default {
  props: {
    imageId: { type: String, required: true },
    aspect: { type: String, required: false, default: 'F169' },
    reset: { type: Boolean, required: false },
    inline: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      inViewport: false
    }
  },
  computed: {
    src() {
      const modifiers =
        this.inline || this.reset
          ? `&size=12&perspective=RICH&alignment=LEFT&type=image&aspect=${
              this.aspect
            }&parentSize=18`
          : ''

      return '/serum/render?id=' + this.imageId + modifiers
    },
    className() {
      if (this.reset) return ''

      return this.inline
        ? `container g66 s12 sl18 sg6 sg9 image-reference image-reference--${this.aspect || 'F169'}`
        : `container image responsive-img ${this.aspect || 'F169'}`
    }
  },
  components: {
    Esi
  }
}
</script>
